//--
import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
 

import { RequestType } from "../../../types/enums/request-enums";
const GetMailLogByReceiver=(data:any):Promise<any>=>request({
  url:ApiURL.Query.GetMailLogByReceiver,
  method: RequestType.POST,
  data
 });  

 const GetSmsLogByPhone=(data:any):Promise<any>=>request({
  url:ApiURL.Query.GetSmsLogByPhone,
  method: RequestType.POST,
  data
 });
 

const EmailAndSmsServiceLogsQuery = {
  GetMailLogByReceiver,
  GetSmsLogByPhone
};

export default EmailAndSmsServiceLogsQuery;
